<template>
  <div>
    <alerts
      module="cart"
    />
    <div class="d-flex align-center justify-space-between py-4 px-4">
      <span class="text-h6">Shopping Cart</span>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider />

    <div v-if="!isCartEmpty">
      <v-list>
        <v-list-item
          v-for="(item, index) in data"
          threeLine
          :key="item.id"
        >
          <v-list-item-content class="mr-4">
            <v-list-item-title class="text-wrap">{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
          </v-list-item-content>

          <div class="d-flex align-end flex-column">
            <the-price :price="item.priceSettings.price" class="mr-5" />
            <the-quantity :value="item.quantity" @input="(val) => updateItemQuantity(item, val)" />
          </div>
          <v-list-item-action>
            <v-btn icon large @click="removeItem(index)">
              <v-icon color="red">mdi-close-circle</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider class="mb-4" />

      <div class="text-right pt-0 d-flex align-center justify-end col col-12">
        <span class="text-body-2 grey--text text--darken-1">{{ numberOfItemsStr }}</span>
        <div class="v-responsive grey--text subtitle text--darken-2 font-weight-medium shrink d-inline-flex justify-end" tag="span" style="min-width: 100px;">
          <the-price :price="subtotal" />
        </div>
      </div>

      <div class="ma-8">
        <v-btn
          rounded
          block
          color="green"
          dark
          :loading="checkoutLoading"
          @click="checkout"
        >Checkout</v-btn>
      </div>
    </div>

    <v-list v-if="isCartEmpty">
      <div class="ma-8">
        <v-list-item class="mb-8">
          <v-list-item-title class="text-center body-2">Shopping Cart Empty</v-list-item-title>
        </v-list-item>

        <v-btn block color="primary" @click="close">Continue Shopping</v-btn>
      </div>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TheQuantity from './utilities/theQuantity.vue';
import ThePrice from './utilities/thePrice.vue';

export default {
  name: 'TheCart',
  components: {
    TheQuantity,
    ThePrice
  },
  data: function () {
    return {
      headers: [
        {
          text: 'Product',
          value: 'title'
        },
        {
          text: 'Price',
          value: 'variant.price'
        }
      ],
      quantityRules: [
        quantity => !!quantity || 'This field is required',
        quantity => (quantity && quantity >= 1) || 'Quantity should be above 1'
      ],
      checkoutLoading: false
    };
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    removeItem: function (index) {
      this.$store.commit('cart/removeItem', index);
    },
    updateItemQuantity: function (item, newValue) {
      if (item.quantity !== newValue) {
        this.$store.commit('cart/updateItemQuantities', { item, newValue });
      }
    },
    checkout: function () {
      this.checkoutLoading = true;
      this.$store.dispatch('cart/getCheckoutSession', this.checkoutPayload)
        .then((response) => {
          this.checkoutLoading = false;
          if (response) {
            window.open(response, '_self');
          }
        });
    },
    getProductType: function (product) {
      return product?.programs ? 'package' : 'program';
    }
  },
  computed: {
    checkoutPayload: function () {
      const items = [];
      for (const item of this.data) {
        if (item.quantity > 0) {
          items.push({
            ProductId: item.id,
            Quantity: item.quantity,
            ProductType: this.getProductType(item)
          });
        }
      }
      return items;
    },
    numberOfItems: function () {
      let ret = 0;
      for (const item of this.data) {
        ret += item.quantity;
      }
      return ret;
    },
    numberOfItemsStr: function () {
      const numItems = this.numberOfItems;
      if (numItems > 1) {
        return `Subtotal: (${numItems} items):`;
      }
      return `Subtotal: (${numItems} item):`;
    },
    subtotal: function () {
      let total = 0;
      for (const item of this.data) {
        if (item?.priceSettings?.price) {
          total += item.priceSettings.price.toFixed(2) * item.quantity;
        }
      }
      return total;
    },
    isCartEmpty: function () {
      return !this.data || this.data.length === 0;
    },
    ...mapState('cart', ['data'])
  }
};
</script>
